module.exports = __webpack_public_path__ + "static/media/magnifying-glass.f35b768d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/icons/magnifying-glass.svg
// module id = 740
// module chunks = 0